import axios from '@/lib/axios'

class TemplateService {
    all() {
        return axios.get('/template');
    }
}

export default new TemplateService();